export default __webpack_public_path__ + "static/media/Earth.38580a9b.svg";